(function () {
  if (document.querySelector('script[data-fv-stockist]')) return;
  if (!document.querySelector('[data-stockist-widget-tag], stockist-store-locator')) return;

  const shopIcon =
    '<svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.0096 0.25839C19.0618 0.261792 19.1119 0.283634 19.1488 0.321432C19.1857 0.359207 19.2064 0.409485 19.2064 0.46167C19.2064 0.513855 19.1857 0.564132 19.1488 0.601908C19.1119 0.639705 19.0618 0.661547 19.0096 0.66495C19.0096 0.66495 19.0096 0.66495 19.0096 0.66495C19.0467 0.663387 18.9882 0.673522 18.97 0.68007C18.5847 0.747094 18.3005 0.754051 17.9712 0.782532C17.3265 0.830159 16.6839 0.868051 16.0408 0.901469C13.5449 1.0292 11.0459 1.091 8.55529 1.13409C7.50206 1.15334 6.44747 1.16641 5.405 1.19814C4.91094 1.21446 4.42656 1.23445 3.95063 1.27806C3.71583 1.30022 3.48036 1.32839 3.27745 1.37363C3.17967 1.39468 3.08226 1.42793 3.0512 1.44407C3.02088 1.49627 3.10574 1.27996 3.06931 1.42075C3.0173 2.05501 2.71665 2.78631 2.36673 3.25229C2.2553 3.38169 2.30804 3.64995 2.24706 4.10649C2.20226 4.30827 2.11333 4.47444 2.02163 4.61891C1.96113 4.71368 1.89771 4.80011 1.83723 4.88197L1.85822 4.84224C1.79481 4.97028 1.73867 5.09964 1.69322 5.23171L1.69793 5.20995C1.68115 5.2742 1.67472 5.36639 1.66857 5.46168C1.66516 5.51388 1.64332 5.56393 1.60553 5.60084C1.56775 5.63775 1.51747 5.65848 1.46529 5.65848C1.4131 5.65848 1.36283 5.63775 1.32505 5.60084C1.28725 5.56393 1.26541 5.51388 1.26201 5.46168C1.26201 5.46168 1.26201 5.46168 1.26201 5.46168C1.25646 5.36496 1.24709 5.26395 1.26042 5.13808L1.26513 5.11632C1.29835 4.9564 1.34442 4.80048 1.39766 4.64966L1.41866 4.60993C1.46892 4.52147 1.51617 4.43724 1.55584 4.35512C1.61659 4.23012 1.65845 4.10939 1.66773 4.00464C1.69371 3.8107 1.52908 3.37387 1.76664 2.9073C2.07904 2.36159 2.20138 1.92593 2.22201 1.34931C2.22487 1.29645 2.22765 1.15065 2.30427 1.00248C2.37884 0.856355 2.4922 0.76195 2.57943 0.703846C2.7599 0.587952 2.90392 0.544868 3.04329 0.500963C3.32117 0.419436 3.57732 0.375239 3.83386 0.335358C4.34829 0.258362 4.84534 0.214086 5.35219 0.177464C6.41716 0.10319 7.47657 0.0695139 8.5362 0.0500951C11.0393 0.00681165 13.5428 0.0608134 16.0368 0.164594C16.6789 0.190723 17.3209 0.22002 17.9625 0.2473C18.2715 0.258943 18.6338 0.279631 18.884 0.271643C18.9208 0.267444 18.9166 0.262884 19.0096 0.25839Z" fill="black"/><path d="M1.46325 5.98116C1.41075 5.97789 1.36059 5.95563 1.32383 5.91738C1.28707 5.87916 1.26672 5.82839 1.26725 5.77587C1.26779 5.72335 1.28918 5.67301 1.32671 5.63554C1.36424 5.59806 1.41485 5.57683 1.46741 5.57463C1.90422 5.55676 2.34236 5.54302 2.77972 5.53225C3.31748 5.52085 3.84172 5.50576 4.39989 5.52186C5.23654 5.58972 5.9916 5.62058 6.80123 5.61524C8.36894 5.60329 9.95499 5.54856 11.5445 5.53773C12.4093 5.52188 13.3278 5.59573 14.1559 5.66023C14.2865 5.66917 14.4228 5.67574 14.5585 5.68111C15.3727 5.7111 16.2058 5.71219 17.039 5.72142C17.8464 5.72594 18.6896 5.73088 19.4098 5.61298C20.0254 5.49616 20.6367 5.46067 21.2309 5.44489C21.238 5.45511 21.2821 5.40977 21.1197 5.50165C21.0779 5.53047 21.0056 5.60194 20.974 5.70319C20.9418 5.80433 20.957 5.88614 20.968 5.92611C20.9936 6.00623 21.0049 6.00477 20.9977 5.99612C20.4931 5.01414 20.419 4.15245 20.1864 3.29773C20.0613 2.79498 19.8431 2.35962 19.6227 1.81632L19.6329 1.83781C19.5726 1.70884 19.5036 1.57631 19.4338 1.44327C19.2878 1.16413 19.1328 0.885429 18.9989 0.578025L19.0095 0.597413C18.969 0.521264 18.8934 0.424113 18.8219 0.330173C18.7899 0.288378 18.7738 0.235907 18.7786 0.183078C18.7834 0.130261 18.8084 0.0816093 18.8484 0.0475851C18.8884 0.0135609 18.9404 -0.00329424 18.9933 0.000487864C19.0463 0.00425853 19.0955 0.0285513 19.1316 0.0667992C19.1316 0.0667992 19.1316 0.0667992 19.1316 0.0667992C19.2142 0.156016 19.2989 0.238458 19.3869 0.364857L19.3975 0.384245C19.5434 0.644517 19.722 0.905115 19.8954 1.17218C19.9788 1.30059 20.0625 1.43038 20.1435 1.56946L20.1537 1.59095C20.3791 2.0312 20.6886 2.54755 20.8663 3.08725C21.1603 3.94831 21.3774 4.90311 21.7421 5.50782C21.7584 5.53544 21.7938 5.57118 21.8311 5.69332C21.8478 5.75419 21.8648 5.85857 21.8257 5.9805C21.7876 6.1025 21.7001 6.19124 21.6407 6.23243C21.404 6.37195 21.3573 6.33186 21.2784 6.34813C20.7034 6.39389 20.1432 6.4549 19.6113 6.57814C18.7044 6.76044 17.8825 6.76562 17.0384 6.78082C16.2043 6.78798 15.3688 6.7957 14.5159 6.76443C14.3725 6.75875 14.2269 6.75156 14.0798 6.74101C13.1918 6.66929 12.3959 6.59238 11.538 6.58622C9.96178 6.55938 8.37486 6.54708 6.77756 6.46122C5.96854 6.41838 5.11335 6.32078 4.3452 6.19393C3.83908 6.13815 3.29687 6.10526 2.7679 6.06742C2.33355 6.03759 1.89688 6.00844 1.46325 5.98116Z" fill="black"/><path d="M20.933 6.30891C20.9361 6.25653 20.9578 6.20628 20.9957 6.16924C21.0335 6.1322 21.0839 6.11139 21.1363 6.11139C21.1887 6.11139 21.2391 6.1322 21.2769 6.16924C21.3148 6.20628 21.3366 6.25653 21.3396 6.30891C21.3396 6.30891 21.3396 6.30891 21.3396 6.30891C21.3587 6.71418 21.3578 7.10738 21.3498 7.50732C21.3436 7.74518 21.3371 7.97869 21.3101 8.23101C21.2562 8.73304 21.117 9.25596 20.8758 9.72074C20.6648 10.0884 20.3522 10.1833 20.1216 10.2733C19.8799 10.3568 19.6533 10.4096 19.4307 10.4617C18.571 10.6265 17.8279 10.6264 16.918 10.3968C16.2981 10.1028 16.2297 9.73897 16.0481 9.4356C15.8953 9.12291 15.7799 8.8154 15.6696 8.51868C15.4445 7.91155 15.3326 7.28005 15.2375 6.708C15.2221 6.61994 15.2052 6.53145 15.1871 6.44347C15.178 6.39923 15.1687 6.35541 15.1591 6.31187C15.1543 6.29018 15.1494 6.26849 15.1446 6.24753C15.1421 6.23688 15.1398 6.22682 15.1374 6.21694C15.1363 6.21216 15.1351 6.20733 15.1342 6.20374C15.1337 6.20188 15.1333 6.20026 15.1333 6.20036C15.1334 6.20078 15.1333 6.20043 15.135 6.20668C15.1357 6.20891 15.1352 6.20782 15.1386 6.21912C15.1404 6.22483 15.1421 6.23102 15.1492 6.25021C15.1545 6.26303 15.1531 6.26468 15.1765 6.31149C15.1995 6.34091 15.1844 6.37377 15.3437 6.50267C15.4122 6.56288 15.6805 6.6677 15.9083 6.5395C16.1198 6.4165 16.1468 6.28446 16.1708 6.22761C16.2212 6.01215 16.19 6.04247 16.1947 6.00989C16.1846 5.93157 16.1886 5.96873 16.1869 5.95603C16.2346 6.18606 16.2606 6.42496 16.2726 6.64519C16.2913 7.013 16.295 7.3256 16.3283 7.64533C16.3692 8.07234 16.3951 8.50735 16.3405 8.979C16.3098 9.43529 16.0343 10.0322 15.772 10.3306C15.597 10.6055 15.18 10.8365 14.9005 10.8737C14.6107 10.9291 14.3698 10.9307 14.1323 10.9346C13.6597 10.9372 13.2109 10.9208 12.7566 10.9104C12.6217 10.907 12.4841 10.9004 12.3252 10.8724C12.1744 10.8514 11.9523 10.7617 11.849 10.6927C11.2752 10.3226 11.1823 9.80812 11.0488 9.40739C10.8897 8.83664 10.7402 8.27851 10.6416 7.67159L10.6375 7.64326C10.6255 7.40501 10.6135 7.1634 10.6053 6.92177C10.5965 6.65053 10.5904 6.37869 10.5985 6.10128C10.6005 5.99151 10.587 5.90177 10.5687 5.75826C10.5631 5.70609 10.5763 5.65295 10.6075 5.61019C10.6387 5.56744 10.6851 5.53862 10.7367 5.53001C10.7884 5.5214 10.8416 5.53364 10.8849 5.56397C10.9284 5.59429 10.9581 5.64027 10.9697 5.69145C10.9697 5.69145 10.9697 5.69145 10.9697 5.69145C10.9953 5.79443 11.0353 5.94988 11.0471 6.08297C11.0686 6.34951 11.1026 6.61324 11.1387 6.87634C11.1711 7.11132 11.2065 7.34666 11.2415 7.58377L11.2374 7.55544C11.3762 8.08449 11.5748 8.63721 11.7708 9.17006C11.9021 9.53632 12.0926 9.88784 12.2578 9.94602C12.3632 9.99902 12.3711 9.99508 12.46 10.0079C12.5406 10.0166 12.6443 10.0172 12.7518 10.0129C13.2074 9.99601 13.6652 9.98758 14.1016 9.96447C14.3161 9.95222 14.5328 9.93456 14.6879 9.8962C14.8536 9.84813 14.8588 9.83925 14.9388 9.73248C15.3898 9.20012 15.326 8.55137 15.2552 7.75757C15.2137 7.39572 15.2067 7.02297 15.1902 6.70694C15.1796 6.51611 15.1607 6.34419 15.126 6.17051C15.1238 6.15561 15.1276 6.19201 15.1173 6.11192C15.122 6.07917 15.0908 6.1094 15.1412 5.8939C15.1652 5.83703 15.1922 5.70499 15.4038 5.58198C15.6316 5.45378 15.8999 5.5586 15.9683 5.61882C16.1276 5.74773 16.1126 5.78062 16.1356 5.81007C16.1591 5.85696 16.1577 5.85868 16.1631 5.87162C16.1702 5.89102 16.172 5.89754 16.1739 5.90368C16.1776 5.91607 16.1774 5.9155 16.1782 5.91834C16.1806 5.92723 16.1813 5.93013 16.1821 5.9332C16.1838 5.93998 16.1845 5.94295 16.1856 5.94738C16.1874 5.95501 16.1891 5.96206 16.1907 5.96881C16.1938 5.98254 16.1966 5.99489 16.1995 6.00783C16.2052 6.03312 16.2106 6.05808 16.2159 6.08288C16.2265 6.13256 16.2365 6.18162 16.2462 6.23119C16.2655 6.32967 16.2834 6.42855 16.2997 6.52844C16.3908 7.12182 16.4796 7.66216 16.6511 8.17045C16.7507 8.46485 16.8486 8.74965 16.9621 9.00596C17.0554 9.25125 17.2739 9.51873 17.2441 9.48342C17.8022 9.65891 18.6274 9.7332 19.2704 9.64082C19.6822 9.58421 20.1968 9.45648 20.234 9.36401C20.4673 8.99178 20.6188 8.58309 20.7124 8.13594C20.7556 7.92826 20.7866 7.69517 20.8159 7.46788C20.8638 7.08308 20.9073 6.68961 20.933 6.30891Z" fill="black"/><path d="M10.5659 5.79719C10.5714 5.74606 10.5935 5.69703 10.6311 5.66087C10.6686 5.62472 10.718 5.60441 10.7692 5.60441C10.8203 5.60441 10.8697 5.62472 10.9072 5.66087C10.9448 5.69703 10.967 5.74606 10.9724 5.79719C10.9724 5.79719 10.9724 5.79719 10.9724 5.79719C10.9943 6.01563 11.0093 6.22935 11.022 6.445C11.0331 6.63598 11.0416 6.82719 11.047 7.01907C11.0445 7.4284 11.0884 7.77255 10.9182 8.30343C10.7676 8.68327 10.6069 9.02195 10.4498 9.36877C10.3673 9.54975 10.2947 9.72953 10.2118 9.92864C10.1228 10.1181 10.0486 10.3891 9.72933 10.6517C9.15619 11.0845 8.54331 11.1279 8.09216 11.2245C8.04268 11.2344 7.99422 11.2425 7.94376 11.2491C7.05243 11.3836 6.29388 10.8171 5.84105 10.4232C5.01547 9.54252 5.19803 8.77762 5.05236 8.07346C4.98883 7.592 4.92722 7.08643 4.93221 6.58834L4.93142 6.57835C4.93326 6.50912 4.93632 6.44126 4.93982 6.37402C4.9513 6.15744 4.96713 5.94401 4.98367 5.73055C4.98771 5.67929 5.00849 5.62965 5.04504 5.59246C5.08156 5.55527 5.13035 5.53358 5.18147 5.53215C5.23259 5.53072 5.28252 5.54964 5.32107 5.58473C5.35964 5.61981 5.38317 5.66821 5.39007 5.71916C5.39007 5.71916 5.39007 5.71916 5.39007 5.71916C5.41867 5.93112 5.44577 6.14322 5.47466 6.35178C5.48366 6.41627 5.49289 6.48085 5.50282 6.54301L5.50203 6.53303C5.58441 7.00102 5.71404 7.446 5.84178 7.91371C6.02292 8.59904 6.20877 9.45801 6.47011 9.61585C6.98496 10.0076 7.3916 10.2379 7.80382 10.174C7.8291 10.1707 7.85384 10.1667 7.87967 10.1616C8.4099 10.0662 8.85015 10.0009 9.10202 9.82211C9.16162 9.83539 9.4002 9.28964 9.60952 8.93478C9.80038 8.60279 10.0049 8.27235 10.1789 7.96202C10.2832 7.77337 10.3568 7.3352 10.4098 6.98291C10.4366 6.79791 10.4622 6.61182 10.487 6.42555C10.5148 6.21589 10.5426 6.00377 10.5659 5.79719Z" fill="black"/><path d="M4.98364 5.69953C4.98913 5.6484 5.01131 5.59938 5.0489 5.56324C5.08646 5.5271 5.13584 5.5068 5.18698 5.50682C5.23812 5.50684 5.28749 5.52716 5.32503 5.56332C5.3626 5.59949 5.38474 5.64853 5.3902 5.69965V5.69965C5.41265 5.91462 5.42933 6.13087 5.4422 6.34661C5.46521 7.20926 5.5737 7.9194 5.30339 8.97355C5.19712 9.23399 5.12432 9.50146 5.02015 9.81494C4.84743 10.3373 4.35892 10.6007 4.11127 10.7537C3.40417 11.085 2.98215 10.9872 2.49342 10.9996C2.40867 10.9973 2.32474 10.9941 2.24168 10.9904C2.12696 10.9781 1.97935 11.0146 1.67193 10.9389C1.35533 10.8498 1.15887 10.6259 1.04592 10.4749C0.844081 10.1955 0.679969 9.99786 0.443729 9.66722C-0.0540166 8.8849 0.0381184 8.17649 0.000926018 7.52297C-0.00144148 7.50727 0.00141716 7.46092 0.00211859 7.44507C0.0941215 6.90912 0.365825 6.61626 0.580716 6.28817C0.692579 6.13726 0.787846 6.01688 0.88895 5.88184C1.01059 5.71999 1.15478 5.52527 1.22817 5.40021C1.24884 5.35313 1.28479 5.3131 1.33154 5.29C1.37826 5.26689 1.43147 5.26246 1.48022 5.27792C1.52896 5.29338 1.56989 5.32767 1.59475 5.37348C1.61964 5.4193 1.62594 5.47274 1.6157 5.52313C1.6157 5.52313 1.6157 5.52313 1.6157 5.52313C1.53282 5.79258 1.44124 5.95802 1.34577 6.16088C1.27262 6.3117 1.1861 6.47632 1.12047 6.60781C0.967505 6.93968 0.783212 7.30151 0.802073 7.53523L0.803265 7.45733C0.903885 8.08458 0.986515 8.7659 1.25745 9.07227C1.42102 9.27175 1.69142 9.57446 1.88862 9.82787C1.95618 9.91201 1.9846 9.91326 1.96145 9.90241C1.94566 9.90492 2.10201 9.90388 2.28597 9.90809C2.36558 9.91102 2.44446 9.91369 2.52257 9.91579C2.93203 9.9323 3.46142 9.90659 3.58303 9.84244C3.89771 9.67387 4.03869 9.58578 4.09229 9.46387C4.2039 9.20098 4.32413 8.88254 4.48443 8.58714C4.68293 8.06369 4.79695 7.10184 4.90722 6.32799C4.93481 6.11858 4.96093 5.90808 4.98364 5.69953Z" fill="black"/><path d="M19.8699 10.1985C19.8718 10.1455 19.8935 10.0948 19.9314 10.0573C19.9693 10.0199 20.0202 9.99884 20.0732 9.99884C20.1261 9.99884 20.177 10.0199 20.215 10.0573C20.2529 10.0948 20.2745 10.1455 20.2765 10.1985C20.2765 10.1985 20.2765 10.1985 20.2765 10.1985C20.2859 10.4671 20.2946 10.7341 20.3032 11.0031C20.3147 11.3604 20.3258 11.7197 20.3366 12.077C20.3609 12.8824 20.3835 13.6869 20.4045 14.4923C20.4402 15.8718 20.4732 17.2509 20.492 18.6332C20.4948 18.8748 20.4957 19.1143 20.4886 19.3625C20.4847 19.487 20.4795 19.6113 20.4661 19.748C20.4324 19.8936 20.4995 20.0048 20.2558 20.3432C19.962 20.6718 19.5548 20.6817 19.3186 20.6696C19.0635 20.6541 18.8538 20.6092 18.6507 20.5693C18.2491 20.4866 17.8817 20.41 17.5296 20.393C16.5718 20.3313 15.6511 20.2808 14.7123 20.2654C14.2638 20.2526 13.8325 20.2909 13.3427 20.3104C12.6972 20.3321 12.0857 20.326 11.4848 20.3553C11.3514 20.3618 11.2241 20.3686 11.0918 20.3764C10.4021 20.415 9.80486 20.4783 9.07107 20.5894C8.59299 20.6432 8.08893 20.6795 7.60836 20.7007C6.82875 20.73 6.09047 20.6967 5.33522 20.6364C4.48013 20.5653 3.5819 20.4403 2.77396 20.2507C2.45205 20.1847 2.15975 20.1651 1.73878 20.0386C1.44802 19.9401 1.30296 19.716 1.22559 19.5683C1.14553 19.4115 1.10423 19.2761 1.06603 19.1468C0.99305 18.8902 0.943628 18.6578 0.882763 18.4358C0.631065 17.3498 0.91881 16.4131 1.0432 15.5509C1.09965 15.1446 1.14135 14.7459 1.17561 14.3367C1.23525 13.6099 1.28095 12.8737 1.32308 12.1413C1.32311 12.1449 1.32321 12.1411 1.32332 12.1374C1.34537 11.6206 1.32745 11.1095 1.42807 10.558L1.4322 10.5383C1.47146 10.4252 1.46743 10.4021 1.4611 10.2892C1.45664 10.2364 1.47201 10.1834 1.50517 10.1416C1.53831 10.0999 1.58632 10.0729 1.63887 10.0665C1.69142 10.0601 1.74448 10.0749 1.78665 10.1075C1.82882 10.1401 1.85642 10.1879 1.86471 10.2402C1.86471 10.2402 1.86471 10.2402 1.86471 10.2402C1.88702 10.3457 1.88358 10.5494 1.84873 10.6461L1.85287 10.6264C1.79869 11.0966 1.84592 11.6226 1.85862 12.1353C1.85875 12.1391 1.85889 12.1428 1.85902 12.1466C1.86442 12.8934 1.86351 13.6302 1.8446 14.3739C1.83336 14.7905 1.812 15.2144 1.77598 15.6293C1.67411 16.5671 1.50199 17.482 1.71172 18.1913C1.78908 18.4349 1.85142 18.6765 1.91973 18.8841C1.96999 19.0935 2.13076 19.2529 2.02287 19.1635C2.23653 19.2227 2.6072 19.2579 2.93455 19.311C3.78318 19.4797 4.57246 19.5646 5.40987 19.6175C6.12321 19.6595 6.86059 19.6775 7.55169 19.6416C8.02835 19.6138 8.47948 19.5767 8.95327 19.5199C9.57608 19.4172 10.3473 19.3296 11.0278 19.2941C11.1647 19.2861 11.2957 19.2792 11.4325 19.2727C12.0737 19.2427 12.7074 19.2521 13.3041 19.2368C13.7495 19.2234 14.2509 19.1865 14.7384 19.2074C15.6945 19.2362 16.6638 19.3087 17.594 19.3923C18.0484 19.4264 18.4718 19.5313 18.8567 19.6217C19.224 19.7306 19.6568 19.7193 19.5649 19.7192C19.4751 19.8703 19.5534 19.729 19.5536 19.6425C19.5671 19.5432 19.5763 19.4321 19.5839 19.3197C19.5988 19.0935 19.6071 18.8614 19.6137 18.6267C19.6497 17.2515 19.6825 15.8701 19.7236 14.4912C19.7474 13.6857 19.7733 12.8811 19.8013 12.0758C19.8138 11.7185 19.8267 11.3592 19.8399 11.002C19.8497 10.7333 19.86 10.4654 19.8699 10.1985Z" fill="black"/><path d="M13.8965 19.7157C13.8918 19.7672 13.8698 19.8166 13.8321 19.8531C13.7945 19.8895 13.7447 19.91 13.6932 19.91C13.6416 19.91 13.5919 19.8895 13.5543 19.8531C13.5166 19.8166 13.4946 19.7672 13.4899 19.7157C13.4899 19.7157 13.4899 19.7157 13.4899 19.7157C13.4668 19.4673 13.4441 19.215 13.4223 18.9644C13.3631 18.2838 13.3102 17.6045 13.2641 16.9235C13.2368 16.5384 13.1928 16.1599 13.1129 15.8069C13.05 15.4747 12.8553 15.069 12.8006 15.0716C12.4233 14.8215 12.0613 15.0054 11.0809 15.0849C10.9848 15.0803 10.8892 15.0763 10.7931 15.0726C10.1337 15.0493 9.43488 15.0377 8.81998 15.071C8.85889 15.0789 9.0576 14.9896 9.10167 14.905C9.15294 14.8292 9.14543 14.8166 9.14665 14.8168C9.14305 14.8219 9.13214 14.8717 9.12456 14.9197C9.10841 15.0199 9.09457 15.1368 9.08071 15.253C8.99787 15.9753 8.91986 16.7149 8.83346 17.4474C8.7624 18.0449 8.69348 18.6349 8.59215 19.2429C8.58406 19.2889 8.57549 19.3351 8.56634 19.3811L8.5589 19.4192C8.51366 19.5464 8.45981 19.6576 8.41257 19.7613L8.4173 19.7462C8.39565 19.8128 8.34361 19.9473 8.29334 20.0251C8.26642 20.0693 8.22485 20.104 8.17497 20.1201C8.12512 20.1362 8.07146 20.1327 8.02519 20.1099C7.97893 20.0872 7.94332 20.0469 7.92561 19.9976C7.90787 19.9483 7.90989 19.8942 7.92843 19.8459C7.92843 19.8459 7.92843 19.8459 7.92843 19.8459C7.95819 19.7656 7.96246 19.7316 7.98017 19.6258L7.9849 19.6107C8.0159 19.4922 8.04671 19.3831 8.06402 19.283L8.05658 19.3211C8.0579 19.2782 8.05877 19.2351 8.05931 19.1915C8.06145 18.607 8.04756 18.0009 8.04717 17.4029C8.04612 16.659 8.05521 15.9215 8.09139 15.1695C8.09796 15.0473 8.10418 14.9272 8.11788 14.7905C8.12594 14.7198 8.13152 14.6526 8.15943 14.5417C8.17694 14.4847 8.18892 14.4148 8.27555 14.2906C8.35399 14.1566 8.61148 14.0397 8.70975 14.0429C9.4563 13.9657 10.1287 13.966 10.834 13.9893C10.9348 13.9931 11.0351 13.9977 11.1361 14.0032C11.4753 14.0087 12.5884 13.6176 13.3823 14.235C13.9613 14.7536 13.9405 15.2064 14.033 15.6418C14.093 16.0782 14.0975 16.4975 14.0803 16.9143C14.0494 17.5975 14.0087 18.2788 13.9576 18.9613C13.9387 19.2129 13.9185 19.4645 13.8965 19.7157Z" fill="black"/></svg>';
  const shopIconUrl = `url("data:image/svg+xml,${encodeURIComponent(shopIcon)}")`;
  const overrides = `

    #stockist-widget {
      --stockist-side-panel-width: 520px;
    }

    #stockist-widget .stockist-result-panel {
      background-color: #ffffff !important;
      margin-right: 0 !important;
    }

    #stockist-widget .stockist-search-form[data-fv-stockist-search-above-layout] {
      display: block !important;
      width: 50% !important;
      max-width: 50% !important;
      margin: 0 0 24px !important;
      padding: 0 !important;
      grid-area: auto !important;
    }

    #stockist-widget .fv-stockist-search-heading {
      width: 50% !important;
      margin: 0 0 12px !important;
      color: #1c1c1c !important;
      font-family: 'Nunito Sans', var(--font-body--family), sans-serif !important;
      font-size: 16px !important;
      line-height: 24px !important;
      font-weight: 550 !important;
    }

    #stockist-widget .stockist-search-form[data-fv-stockist-search-above-layout] .stockist-search-fields-horizontal {
      display: flex !important;
      align-items: stretch !important;
      gap: 12px !important;
      width: 100% !important;
    }

    #stockist-widget .stockist-search-form[data-fv-stockist-search-above-layout] .stockist-search-wrapper {
      background: transparent !important;
      border: none !important;
      outline: none !important;
      box-shadow: none !important;
      border-radius: 0 !important;
      flex: 1 1 auto !important;
      min-width: 0 !important;
      height: 52px !important;
      display: flex !important;
      align-items: stretch !important;
    }

    #stockist-widget .stockist-search-form[data-fv-stockist-search-above-layout] .stockist-search-field {
      height: 52px !important;
      width: 100% !important;
      background: transparent !important;
      border: 1px solid #6b6b6b !important;
      border-radius: 0 !important;
      overflow: hidden !important;
    }

    #stockist-widget .stockist-search-form[data-fv-stockist-search-above-layout] .stockist-search-field input {
      background: transparent !important;
      height: 100% !important;
      padding: 0 20px !important;
      color: #1c1c1c !important;
      font-family: 'Nunito Sans', var(--font-body--family), sans-serif !important;
      font-size: 15px !important;
      line-height: 20px !important;
      font-weight: 500 !important;
    }

    #stockist-widget .stockist-search-form[data-fv-stockist-search-above-layout] .stockist-search-field input::placeholder {
      color: #4a5565 !important;
      opacity: 1 !important;
    }

    #stockist-widget .stockist-search-form[data-fv-stockist-search-above-layout] .stockist-search-submit {
      flex: 0 0 auto !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      height: 52px !important;
      padding: 0 48px !important;
      background: var(--fv-stockist-icon-color, #00aeef) !important;
      border: 1px solid #000000 !important;
      border-radius: 999px !important;
      cursor: pointer !important;
    }

    #stockist-widget .stockist-search-form[data-fv-stockist-search-above-layout] .stockist-search-button {
      all: unset !important;
      font-family: 'Nunito Sans', var(--font-body--family), sans-serif !important;
      font-size: 13px !important;
      font-weight: 800 !important;
      letter-spacing: 0.08em !important;
      text-transform: uppercase !important;
      color: #000000 !important;
      cursor: pointer !important;
    }

    @media (max-width: 749px) {
      #stockist-widget .fv-stockist-search-heading,
      #stockist-widget .stockist-search-form[data-fv-stockist-search-above-layout],
      #stockist-widget .stockist-search-form[data-fv-stockist-search-above-layout] .stockist-search-fields-horizontal {
        width: 100% !important;
        max-width: 100% !important;
      }

      #stockist-widget .stockist-search-form[data-fv-stockist-search-above-layout] .stockist-search-fields-horizontal {
        flex-direction: column !important;
      }

      #stockist-widget .stockist-search-form[data-fv-stockist-search-above-layout] .stockist-search-wrapper {
        width: 100% !important;
      }

      #stockist-widget .stockist-search-form[data-fv-stockist-search-above-layout] .stockist-search-submit {
        width: 100% !important;
        justify-content: center !important;
      }
    }

    #stockist-widget .stockist-map {
      border-top-left-radius: 0 !important;
      border-bottom-left-radius: 0 !important;
    }

    #stockist-widget .stockist-result-name {
      text-transform: uppercase !important;
    }

    #stockist-widget .fv-stockist-result-title-row {
      display: flex !important;
      align-items: baseline !important;
      justify-content: space-between !important;
      gap: 12px !important;
      margin-top: 0 !important;
      width: 100% !important;
      box-sizing: border-box !important;
      padding-right: 24px !important;
    }

    #stockist-widget .fv-stockist-result-title-row .stockist-result-name {
      flex: 1 1 auto !important;
      min-width: 0 !important;
      margin: 0 !important;
    }

    #stockist-widget .fv-stockist-view-store {
      flex: 0 0 auto !important;
      margin-left: auto !important;
      white-space: nowrap !important;
      text-align: right !important;
      font-family: 'Nunito Sans', var(--font-body--family), sans-serif !important;
      font-size: 12px !important;
      line-height: 18px !important;
      font-weight: 700 !important;
      letter-spacing: 0.04em !important;
      text-decoration: underline !important;
      text-underline-offset: 2px !important;
      text-transform: uppercase !important;
      color: #1c1c1c !important;
    }

    #stockist-widget .fv-stockist-view-store:hover {
      color: var(--fv-stockist-icon-color, #00aeef) !important;
    }

    #stockist-widget .stockist-result-phone,
    #stockist-widget .stockist-result-email {
      display: none !important;
    }

    #stockist-widget .stockist-result-address,
    #stockist-widget .stockist-result-address *,
    #stockist-widget .stockist-result-details,
    #stockist-widget .stockist-result-details * {
      color: #4a5565 !important;
      font-size: 13px !important;
      line-height: 18px !important;
    }

    #stockist-widget .stockist-icon-marker {
      display: inline-block !important;
      width: 22px !important;
      height: 21px !important;
      background-color: var(--fv-stockist-icon-color, #00aeef) !important;
      -webkit-mask: ${shopIconUrl} center / contain no-repeat !important;
      mask: ${shopIconUrl} center / contain no-repeat !important;
    }

    #stockist-widget .stockist-icon-marker::before,
    #stockist-widget .stockist-icon-marker svg {
      content: '' !important;
      display: none !important;
    }
  `;
  /** @param {Document | ShadowRoot | HTMLElement} root */
  const arrangeSearchAboveLayout = (root) => {
    let animationFrameId = 0;
    /** @type {MutationObserver | null} */
    let observer = null;

    /**
     * Stockist renders locality as "City, State Postal" then country alone.
     * Move postal onto the country line: "Country Postal".
     * @param {ParentNode} widget
     */
    const reorderAddressPostal = (widget) => {
      const addresses = Array.from(widget.querySelectorAll?.('.stockist-result-address') || []);

      addresses.forEach((address) => {
        if (!(address instanceof HTMLElement)) return;
        if (address.hasAttribute('data-fv-postal-reordered')) return;

        const postal =
          address.querySelector('.stockist-address-postal-code') ||
          address.querySelector('.stockist-result-addr-postal');
        const country = address.querySelector('.stockist-result-addr-country');

        if (!(postal instanceof HTMLElement) || !(country instanceof HTMLElement)) {
          address.setAttribute('data-fv-postal-reordered', '');
          return;
        }

        const previous = postal.previousSibling;
        if (
          previous instanceof HTMLElement &&
          (previous.classList.contains('stockist-address-separator-2') ||
            previous.classList.contains('stockist-address-separator-1'))
        ) {
          // Only remove the postal spacer (" "), keep the city/state comma separator
          if (previous.classList.contains('stockist-address-separator-2')) {
            previous.remove();
          } else if (!address.querySelector('.stockist-address-state')) {
            // "City, Postal" with no state — drop the orphaned comma before postal
            previous.remove();
          }
        } else if (previous?.nodeType === Node.TEXT_NODE && /^\s+$/.test(previous.textContent || '')) {
          previous.remove();
        }

        postal.remove();
        country.appendChild(document.createTextNode(' '));
        country.appendChild(postal);
        address.setAttribute('data-fv-postal-reordered', '');
      });
    };

    /**
     * Move "View Store(s)" custom-field link onto the same row as the store title,
     * right-aligned.
     * @param {ParentNode} widget
     */
    const alignViewStoreWithTitle = (widget) => {
      const results = Array.from(widget.querySelectorAll?.('.stockist-result') || []);

      results.forEach((result) => {
        if (!(result instanceof HTMLElement)) return;
        if (result.querySelector('.fv-stockist-result-title-row')) return;

        const name = result.querySelector('.stockist-result-name');
        if (!(name instanceof HTMLElement)) return;

        const customLinks = Array.from(
          result.querySelectorAll?.(
            '.stockist-result-custom-fields a, .stockist-result-custom-field a, a[href*="store-location"]'
          ) || []
        );

        const viewStoreLink = customLinks.find((link) => {
          if (!(link instanceof HTMLAnchorElement)) return false;
          const label = link.textContent?.replace(/\s+/g, ' ').trim() || '';
          const href = link.getAttribute('href') || '';
          return /view\s*stores?/i.test(label) || href.includes('store-location');
        });

        if (!(viewStoreLink instanceof HTMLAnchorElement)) return;

        const row = document.createElement('div');
        row.className = 'fv-stockist-result-title-row';

        const customFieldItem = viewStoreLink.closest?.('.stockist-result-custom-field, li');
        const customFieldsList = result.querySelector?.('.stockist-result-custom-fields');

        name.replaceWith(row);
        row.appendChild(name);

        viewStoreLink.classList.add('fv-stockist-view-store');
        viewStoreLink.removeAttribute('target');
        row.appendChild(viewStoreLink);

        customFieldItem?.remove();
        if (customFieldsList && !customFieldsList.querySelector('li, a, .stockist-result-custom-field')) {
          customFieldsList.remove();
        }
      });
    };

    const moveSearchForm = () => {
      animationFrameId = 0;

      const widget = root.querySelector?.('#stockist-widget') || root;
      const layout = widget.querySelector?.('.stockist-layout') || widget.querySelector?.('.stockist-horizontal');
      const searchForms = Array.from(widget.querySelectorAll?.('.stockist-search-fields-horizontal') || [])
        .map((searchFields) => searchFields.closest?.('.stockist-search-form') || searchFields.closest?.('form'))
        .filter((form, index, forms) => form && forms.indexOf(form) === index);
      const searchForm = searchForms[0];

      // Physically remove duplicate forms instead of hiding with CSS
      if (searchForms.length > 1) {
        observer?.disconnect();
        searchForms.slice(1).forEach((form) => form?.remove());
        observer?.observe(root, { childList: true, subtree: true });
      }

      if (searchForm) {
        searchForm.setAttribute('data-fv-stockist-search-above-layout', '');
      }

      // Force 50% width via inline style so Stockist's ResizeObserver can't override it
      if (searchForm instanceof HTMLElement) {
        searchForm.style.setProperty('width', '50%', 'important');
        searchForm.style.setProperty('max-width', '50%', 'important');
      }

      // Set button text (use data attribute to avoid triggering MutationObserver loop)
      const searchButton = searchForm?.querySelector?.('.stockist-search-button');
      if (searchButton && !searchButton.hasAttribute('data-fv-label-set')) {
        searchButton.textContent = 'SEARCH';
        searchButton.setAttribute('data-fv-label-set', '');
      }

      // Re-apply heading inline styles on every call (Stockist may reset them)
      const existingHeading = widget.querySelector?.('.fv-stockist-search-heading');
      if (existingHeading instanceof HTMLElement) {
        existingHeading.style.setProperty('font-size', '16px', 'important');
        existingHeading.style.setProperty('font-weight', '550', 'important');
        existingHeading.style.setProperty('line-height', '24px', 'important');
        existingHeading.style.setProperty('color', '#1c1c1c', 'important');
      }

      reorderAddressPostal(widget);
      alignViewStoreWithTitle(widget);

      if (!layout || !searchForm || !layout.parentNode || layout.previousElementSibling === searchForm) return;

      let heading = existingHeading;
      if (!heading) {
        heading = document.createElement('div');
        heading.textContent = 'Find your nearest Fluevog store';
      }

      heading.className = 'fv-stockist-search-heading fv-store__description fv-stores-page__intro-text';
      if (heading instanceof HTMLElement) {
        heading.style.setProperty('font-family', "'Nunito Sans', sans-serif", 'important');
        heading.style.setProperty('font-size', '16px', 'important');
        heading.style.setProperty('font-weight', '550', 'important');
        heading.style.setProperty('line-height', '24px', 'important');
        heading.style.setProperty('color', '#1c1c1c', 'important');
      }

      layout.parentNode.insertBefore(heading, layout);
      layout.parentNode.insertBefore(searchForm, layout);

    };

    const scheduleMove = () => {
      if (animationFrameId) return;
      animationFrameId = window.requestAnimationFrame(() => {
        // Keep our overrides after Stockist's own style tag so they always win
        const overrideStyle = root.querySelector?.('style[data-fv-stockist-overrides]');
        if (overrideStyle && root.lastChild !== overrideStyle) {
          root.appendChild(overrideStyle);
        }
        moveSearchForm();
      });
    };

    scheduleMove();

    observer = new MutationObserver(scheduleMove);
    observer.observe(root, { childList: true, subtree: true });
  };

  /** @param {Document | ShadowRoot | HTMLElement} root */
  const injectOverrides = (root) => {
    if (!root || root.querySelector?.('style[data-fv-stockist-overrides]')) return;

    const style = document.createElement('style');
    style.dataset.fvStockistOverrides = 'true';
    style.textContent = overrides;
    root.appendChild(style);

    if (root !== document.head) {
      arrangeSearchAboveLayout(root);
    }
  };

  injectOverrides(document.head);
  arrangeSearchAboveLayout(document);

  if (Element.prototype.attachShadow) {
    const originalAttachShadow = Element.prototype.attachShadow;

    /** @param {ShadowRootInit} init */
    Element.prototype.attachShadow = function (init) {
      const root = originalAttachShadow.call(this, init);

      if (this.tagName === 'STOCKIST-STORE-LOCATOR') {
        injectOverrides(root);
        Element.prototype.attachShadow = originalAttachShadow;
      }

      return root;
    };
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://stockist.co/embed/v1/widget.min.js';
  script.dataset.fvStockist = 'true';
  document.head.appendChild(script);
})();
